import React from "react";

/**
 * TimeInputs Component
 * Editable time inputs for both 24-hour and 12-hour formats
 */
const TimeInputs = ({
  timeFormat,
  startTimeEdit24,
  endTimeEdit24,
  startTimeEdit,
  endTimeEdit,
  onStartTimeChange24,
  onEndTimeChange24,
  onStartTimeChange,
  onEndTimeChange,
  onStartTimeBlur,
  onEndTimeBlur,
  onStartTimeFocus,
  onEndTimeFocus,
  uStartTimeError,
  uEndTimeError,
  startInputRef,
  endInputRef,
  start12TimeInputRef,
  end12TimeInputRef,
  editedId,
  groupId,
  className = "",
}) => {
  const isEditing = editedId === groupId;
  const inputClassName = isEditing ? "edit-time" : "";

  if (timeFormat === 24) {
    return (
      <div className={`time-overview-sec ${className}`}>
        <input
          ref={startInputRef}
          type="text"
          name="start_time"
          value={startTimeEdit24}
          style={{ backgroundColor: uStartTimeError && "#fddada" }}
          onChange={onStartTimeChange24}
          onBlur={onStartTimeBlur}
          onFocus={onStartTimeFocus}
          className={`${inputClassName} edit-time-start`}
          autoComplete="off"
        />
        -
        <input
          ref={endInputRef}
          type="text"
          name="end_time"
          value={endTimeEdit24}
          style={{ backgroundColor: uEndTimeError && "#fddada" }}
          onChange={onEndTimeChange24}
          onBlur={onEndTimeBlur}
          onFocus={onEndTimeFocus}
          className={`${inputClassName} edit-time-end`}
          autoComplete="off"
        />
      </div>
    );
  }

  return (
    <div className={`time-overview-sec ${className}`}>
      <input
        ref={start12TimeInputRef}
        type="text"
        name="start_time"
        value={startTimeEdit}
        style={{ backgroundColor: uStartTimeError && "#fddada" }}
        onChange={onStartTimeChange}
        onBlur={onStartTimeBlur}
        onFocus={onStartTimeFocus}
        className={`${inputClassName} edit-time-start`}
        autoComplete="off"
      />
      -
      <input
        ref={end12TimeInputRef}
        type="text"
        name="end_time"
        value={endTimeEdit}
        style={{ backgroundColor: uEndTimeError && "#fddada" }}
        onChange={onEndTimeChange}
        onBlur={onEndTimeBlur}
        onFocus={onEndTimeFocus}
        className={`${inputClassName} edit-time-end`}
        autoComplete="off"
      />
    </div>
  );
};

export default TimeInputs;
